import React from 'react';
import Footer from '../footer';
import TopStripe from '../topStripe';
import Main from './main';

function Home() {
  return (
    <>
      <div className="home">
        <TopStripe />
        <Main />
        <Footer />
      </div>
    </>
  );
}

export default Home;
